import React from "react";
import { FaCheck } from "react-icons/fa";

import { FaXTwitter, FaTelegram, FaGlobe } from "react-icons/fa6";



const visionItems = [
  {
    icon: "/md.png",
    title: "AI-POWERED\nINTELLIGENCE",
  },
  {
    icon: "/stable.png",
    title: "SECURE &\nTRANSPARENT",
  },
  {
    icon: "/revenue.png",
    title: "REAL REVENUE\nGENERATION",
  },
  {
    icon: "/comm.png",
    title: "COMMUNITY\nDRIVEN",
  },
];

const roadmap = [
  {
    phase: "01",
    title: "PROJECT\nLAUNCH",
    icon: "/df.png",
    date: "COMPLETED",
    items: [
      "Project concept finalization",
      "Team building",
      "Whitepaper release",
      "Website & branding",
      "Community building",
    ],
  },
  {
    phase: "02",
    title: "PRESALE\n& TOKEN LAUNCH",
    icon: "/sd.png",
    date: "Q2 2026",
    items: [
      "Presale launch (4 stages)",
      "Community expansion",
      "Token launch on Ethereum",
      "Liquidity provision",
      "DEX listing",
    ],
  },
  {
    phase: "03",
    title: "AI TRADING BOT\nDEVELOPMENT",
    icon: "/md.png",
    date: "Q3 2026",
    items: [
      "Core AI model development",
      "Backtesting & optimization",
      "Risk management system",
      "Trading algorithm integration",
      "Secure smart contracts",
    ],
  },
  {
    phase: "04",
    title: "PLATFORM\nBETA LAUNCH",
    icon: "/ch.png",
    date: "Q4 2026",
    items: [
      "AI Trading Bot beta release",
      "User dashboard launch",
      "Performance analytics",
      "$ETHRA staking (beta)",
      "Early user rewards",
    ],
  },
  {
    phase: "05",
    title: "PLATFORM\nEXPANSION",
    icon: "/wr.png",
    date: "Q1 2027",
    items: [
      "Full platform launch",
      "Mobile app release",
      "Cross-chain integration",
      "Partnerships & integrations",
      "Global marketing push",
    ],
  },
  {
    phase: "06",
    title: "ECOSYSTEM\nGROWTH",
    icon: "/comm.png",
    date: "Q2 2027\nAND BEYOND",
    items: [
      "AI model upgrades",
      "New trading strategies",
      "DAO & governance",
      "Real-world partnerships",
      "Mass adoption",
    ],
  },
];

function TimelineDot() {
  return (
    <div className="absolute left-1/2 top-[-2px] z-40 hidden -translate-x-1/2 xl:flex">
      <div className="relative flex h-[34px] w-[34px] items-center justify-center rounded-full bg-[linear-gradient(180deg,#f2ffb8,#c4dc5b,#92b020)] shadow-[0_0_24px_rgba(196,220,91,0.8)]">
        <div className="absolute top-[3px] h-[6px] w-[18px] rounded-full bg-white/40 blur-[1px]" />
        <div className="flex h-[22px] w-[22px] items-center justify-center rounded-full bg-black">
          <div className="h-[10px] w-[10px] rounded-full bg-[radial-gradient(circle_at_30%_30%,#fff,#bee104,#689203)] shadow-[0_0_12px_rgba(196,220,91,0.8)]" />
        </div>
      </div>
    </div>
  );
}

function PhaseBadge({ phase }) {
  return (
    <div className="absolute left-1/2 top-[-88px] z-30 flex -translate-x-1/2 flex-col items-center">
      <div className="hidden h-[50px] w-[6px] rounded-full bg-[linear-gradient(to_right,#8ea62a,#e7f7a8,#8ea62a)] shadow-[0_0_18px_rgba(196,220,91,0.8)] xl:block" />

      <div
        className="relative flex h-[112px] w-[100px] flex-col items-center justify-center bg-[#c4dc5b] shadow-[0_0_18px_rgba(196,220,91,0.5)]"
        style={{
          clipPath:
            "polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%)",
        }}
      >
        <div
          className="absolute inset-[3px] bg-[#030603]"
          style={{
            clipPath:
              "polygon(50% 0%,100% 25%,100% 75%,50% 100%,0% 75%,0% 25%)",
          }}
        />

        <span
          className="relative text-[40px] font-extrabold leading-none"
          style={{
            background:
              "linear-gradient(180deg,#f2ff9a 0%,#bee104 25%,#9bc208 50%,#689203 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            filter: "drop-shadow(0 0 8px rgba(190,225,4,0.7))",
          }}
        >
          {phase}
        </span>

        <span className="relative mt-1 text-[14px] font-extrabold uppercase text-white">
          PHASE
        </span>
      </div>
    </div>
  );
}

export default function Roadmap() {
  return (
    <section
      id="roadmap"
      className="relative w-full overflow-hidden bg-black px-4  pt-6 text-white"
    >
      <div
        className="absolute inset-0 hidden opacity-90 md:block"
        style={{
          backgroundImage: "url('/1-Photoroom.png')",
          backgroundSize: "100%",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top center",
        }}
      />

      <div className="absolute inset-0 bg-black/25" />
      <div className="absolute left-0 top-0 h-[420px] w-[420px] rounded-full bg-[#c4dc5b]/10 blur-[120px]" />

      <div className="relative z-20 mx-auto max-w-[1800px]">
        {/* Header Text */}
        <div className="mx-auto flex max-w-[980px] flex-col items-center pt-8 text-center md:pt-14 lg:pt-16">
          <h2 className="font-black uppercase leading-none tracking-[2px] text-[58px] sm:text-[82px] md:text-[108px] lg:text-[128px]">
            <span
              style={{
                color: "#f2f2f2",
                textShadow: `
                  0 1px 0 #ffffff,
                  0 2px 0 #dddddd,
                  0 3px 0 #b8b8b8,
                  0 4px 0 #858585,
                  0 7px 0 #303030,
                  0 12px 22px rgba(0,0,0,0.9)
                `,
              }}
            >
              ROAD
            </span>
            <span
              style={{
                background:
                  "linear-gradient(180deg,#f3ff6a 0%,#d8f21a 18%,#bee104 42%,#8fb903 70%,#5c7d02 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                filter:
                  "drop-shadow(0 2px 0 rgba(50,80,0,0.9)) drop-shadow(0 0 12px rgba(196,220,91,0.45))",
              }}
            >
              MAP
            </span>
          </h2>

          <h3 className="mt-3 text-[17px] font-extrabold uppercase tracking-wide text-white sm:text-[22px] md:text-[27px]">
            BUILDING THE FUTURE OF{" "}
            <span className="text-[#b9df16]">AI-POWERED TRADING</span>
          </h3>

          <p className="mt-5 max-w-[720px] text-center text-[14px] leading-relaxed text-gray-300 sm:text-[16px] md:text-[19px]">
            Ethra AI is on a mission to revolutionize DeFi trading with
            artificial intelligence, transparency, and real revenue.
          </p>
        </div>

        <div className="relative mt-[80px] xl:mt-[92px]">
          {/* Timeline line */}
          <div className="absolute left-[4%] right-[4%] top-[14px] hidden h-[8px] overflow-hidden rounded-full xl:block">
            <div className="absolute inset-0 rounded-full bg-[#92b020]" />
            <div className="absolute left-0 right-0 top-0 h-[2px] rounded-full bg-white/40" />
            <div className="absolute bottom-0 left-0 right-0 h-[2px] rounded-full bg-black/30" />
            <div className="absolute inset-0 rounded-full shadow-[0_0_25px_#c4dc5b]" />
          </div>

          <div className="grid grid-cols-1 gap-x-7 gap-y-28 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
            {roadmap.map((item, index) => (
              <div key={index} className="relative pt-[88px]">
                <TimelineDot />

                <div
                  className="relative flex h-[560px] flex-col rounded-[18px] bg-[#030b03]/90 px-6 pb-6 pt-[80px]"
                  style={{
                    border: "3px solid #71842d",
                    boxShadow:
                      "0 0 10px rgba(196,220,91,0.45), inset 0 0 18px rgba(196,220,91,0.06)",
                  }}
                >
                  <PhaseBadge phase={item.phase} />

                  <div className="flex justify-center">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="h-[82px] w-[92px] object-contain"
                    />
                  </div>

                  <h3 className="mt-5 whitespace-pre-line text-center text-[18px] font-extrabold uppercase leading-[1.2]">
                    {item.title}
                  </h3>

                     <ul className="mt-6 flex-1 space-y-3">
                  {item.items.map((point, i) => (
                    <li
                      key={i}
                      className="flex items-start gap-3 text-[14px] leading-[1.25] text-gray-300"
                    >
                      <span className="mt-[1px] flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full border border-[#c4dc5b] text-[#c4dc5b] shadow-[0_0_8px_rgba(196,220,91,0.6)]">
                        <FaCheck className="text-[10px]" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

                  <div
                    className="mt-7 rounded-[10px] bg-black px-3 py-3 text-center text-[15px] font-bold uppercase"
                    style={{
                      border: "3px solid #4c5c1d",
                      color: "#c4dc5b",
                      boxShadow:
                        "inset 0 0 10px rgba(196,220,91,0.08), 0 0 4px rgba(0,0,0,0.5)",
                    }}
                  >
                    {item.date.split("\n").map((line, i) => (
                      <div key={i}>{line}</div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
       <section className="w-full bg-black px-4 py-8">
      <div className="mx-auto flex w-full max-w-[1800px] flex-col overflow-hidden rounded-[16px] border border-[#c4dc5b]/45 bg-black/80 shadow-[0_0_18px_rgba(196,220,91,0.12)] lg:flex-row">
        {/* Left Image */}
        <div className="relative flex min-h-[170px] items-center justify-center lg:w-[26%]">
          <img
            src="/img123.png"
            alt="Ethra AI"
            className="h-full w-full object-cover"
          />
        </div>

        {/* Middle Text */}
        <div className="relative flex flex-col justify-center px-6 py-8 lg:w-[30%]">
          <h2 className="text-[26px] font-extrabold uppercase text-white md:text-[34px]">
            OUR <span className="text-[#c4dc5b]">VISION</span>
          </h2>

          <p className="mt-3 max-w-[560px] text-[14px] leading-[1.65] text-gray-300 md:text-[16px]">
            To become the leading AI-powered trading ecosystem in DeFi,
            generating real revenue and delivering long-term value to our
            community and holders.
          </p>

          <span className="absolute right-0 top-1/2 hidden h-[75%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent lg:block" />
        </div>

        {/* Right Icons */}
        <div className="grid flex-1 grid-cols-2 md:grid-cols-4">
          {visionItems.map((item, index) => (
            <div
              key={index}
              className="relative flex min-h-[170px] flex-col items-center justify-center px-5 py-7 text-center"
            >
              <img
                src={item.icon}
                alt={item.title}
                className="mb-5 h-[58px] w-[58px] object-contain"
              />

              <h3 className="whitespace-pre-line text-[14px] font-bold uppercase leading-[1.45] text-white md:text-[16px]">
                {item.title}
              </h3>

              {index !== visionItems.length - 1 && (
                <span className="absolute right-0 top-1/2 hidden h-[75%] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b] to-transparent md:block" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>

     <section className="w-full bg-black p">
      <div className="mx-auto flex w-full max-w-[1800px] flex-col gap-5 rounded-[18px] bg-black/80 px-6 py-5 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-col gap-4 md:flex-row md:items-center">
          <div className="relative flex items-center gap-4 pr-8">
            <FaXTwitter className="text-[28px] text-[#9fca14]" />
            <span className="text-[18px] font-semibold text-gray-400">
              @Ethra_AI
            </span>
            <span className="absolute right-0 top-1/2 hidden h-[38px] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b]/40 to-transparent md:block" />
          </div>

          <div className="relative flex items-center gap-4 px-8">
            <FaTelegram className="text-[28px] text-[#9fca14]" />
            <span className="text-[18px] font-semibold text-gray-400">
              t.me/EthraAI
            </span>
            <span className="absolute right-0 top-1/2 hidden h-[38px] w-[2px] -translate-y-1/2 bg-gradient-to-b from-transparent via-[#c4dc5b]/40 to-transparent md:block" />
          </div>

          <div className="flex items-center gap-4 px-8">
            <FaGlobe className="text-[28px] text-[#9fca14]" />
            <span className="text-[18px] font-semibold text-gray-400">
              www.ethraai.com
            </span>
          </div>
        </div>

        <p className="text-[18px] font-semibold uppercase tracking-wide text-gray-400">
          AI-POWERED TRADING.{" "}
          <span className="font-extrabold text-[#9fca14]">REAL REVENUE.</span>{" "}
          REAL VALUE.
        </p>
      </div>
    </section>
    </section>
  );
}